import { Bar, BarChart, CartesianGrid, LabelList, Tooltip, XAxis, YAxis } from 'recharts'
import { Chart, useChart, UseChartProps } from '@chakra-ui/charts'
import { Box } from '@chakra-ui/react'
import { NoData } from '@src/components/NoData/NoData'
import { ChartDataItem } from '@src/components/BarChartComponent/types'
import { roundNumber } from '@src/helpers/utils'

export const BarChartComponent = (props: UseChartProps<ChartDataItem>) => {
    const chart = useChart({
        data: props.data,
        series: props.series,
    })

    if (chart.data.length === 0) {
        return (
            <Box height="300px" width="full" minW="0">
                <NoData />
            </Box>
        )
    }

    return (
        <Chart.Root maxH="md" flex="1" minH="300px" chart={chart}>
            <BarChart layout="vertical" data={chart.data}>
                <CartesianGrid stroke={chart.color('border.muted')} vertical={false} />
                <XAxis type="number" axisLine={false} tickLine={false} />
                <YAxis
                    type="category"
                    dataKey={chart.key('type')}
                    orientation="left"
                    stroke={chart.color('border')}
                />
                <Tooltip
                    cursor={{ fill: chart.color('bg.muted') }}
                    animationDuration={100}
                    content={<Chart.Tooltip />}
                />
                {chart.series.map(item => (
                    <Bar
                        key={String(item.name)}
                        barSize={30}
                        isAnimationActive={true}
                        dataKey={chart.key(String(item.name))}
                        fill={chart.color(item.color)}
                        stroke={chart.color(item.color)}
                    >
                        <LabelList
                            dataKey={chart.key(item.name as string)}
                            position="insideRight"
                            style={{ fontWeight: 500, fill: chart.color('fg.inverted') }}
                            formatter={label => (label ? roundNumber(label.toString()) : '')}
                        />
                    </Bar>
                ))}
            </BarChart>
        </Chart.Root>
    )
}
